<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">

	<!-- 天猫店铺信息 -->
	<div class="backborder1">
	<div class="tmall_shop_setting_add">
		<el-button type="danger" size="small" round @click="addsettingshop">添加天猫店铺设置</el-button>
		<el-button type="primary" size="small" circle icon="el-icon-refresh" @click="getsetting" />
		<span class="tmall_shop_setting_add_notice">（警告：非技术人员请勿对下面店铺设置信息进行改动，否则可能导致天猫店铺数据对接瘫痪）</span>
	</div>
	<div class="tmall_shop_lists" v-loading="query.loading">
		<div class="tmall_shop_lists_infos" v-for="(item,index) in settings" :key="index">
			<div class="tmall_shop_lists_infos_logo"><img src="../../assets/tmall_logo.png" /></div>
			<div v-if="item.status==1 || item.status==2 || item.status==3" :class="item.status==1 ? 'tmall_shop_setting_status_success' : 'tmall_shop_setting_status_error' ">
				<div v-if="item.status==1">授权成功</div>
				<div v-if="item.status==2">即将到期</div>
				<div v-if="item.status==3">授权过期</div>
			</div>
			<div class="tmall_shop_lists_infos_sg">
				<div class="tmall_shop_lists_infos_shopname_title">店铺名称：{{item.tmall_shopname}}</div>
				<div class="tmall_shop_lists_infos_shopname_button">
					<el-tooltip class="item" effect="dark" content="去授权" placement="top">
					<el-button type="warning" size="mini" circle icon="el-icon-setting" @click="gotoauth(item)"></el-button>
					</el-tooltip>
					<el-button type="warning" size="mini" circle icon="el-icon-edit" @click="getsettinginfos(item)"></el-button>
					<el-button type="danger" size="mini" circle icon="el-icon-delete" @click="delsetting(item)"></el-button>
				</div>
			</div>
			<div class="tmall_shop_lists_infos_sg">
				<div class="tmall_shop_lists_infos_shopname_content">店铺ID：{{item.tmall_shopid}}</div>
			</div>
			<div class="tmall_shop_lists_infos_sg">
				<div class="tmall_shop_lists_infos_shopname_content">AppKey：{{item.tmall_appkey}}</div>
			</div>
			<div class="tmall_shop_lists_infos_sg">
				<div class="tmall_shop_lists_infos_shopname_content">AppSecret：{{item.tmall_appsecret}}</div>
			</div>
			<div class="tmall_shop_lists_infos_sg">
				<div class="tmall_shop_lists_infos_shopname_content" v-if="item.status==0">授权状态：未授权</div>
				<div class="tmall_shop_lists_infos_shopname_content" v-if="item.status==1">授权状态：已授权</div>
				<div class="tmall_shop_lists_infos_shopname_content" v-if="item.status==2">授权状态：已授权</div>
			</div>
			<div class="tmall_shop_lists_infos_sg">
				<div class="tmall_shop_lists_infos_shopname_content">到期时间：<i :style="item.status==1 ? 'font-style:normal;' : 'font-style:normal;color:red'">{{item.expiretime}}</i></div>
			</div>
		</div>
	</div>
	</div>

	<!-- 新增店铺设置信息 -->
	<el-dialog title="新增 / 编辑店铺配置信息" :visible.sync="addsettingDialog" width="25%" top="10vh" class="tmall_shop_lists_setting_dialog">
		<div class="tmall_shop_lists_infos_add_logo"><img src="../../assets/tmall_logo.png" /></div>
		<div class="tmall_shop_lists_infos_add_logo_content">
		<el-form :inline="true" size="small">
			<el-form-item label="天猫店铺" label-width="120">
				<el-input v-model="addsettingquery.tmall_shopname" placeholder="请填写天猫店铺名称"></el-input>
			</el-form-item>
			<el-form-item label="店铺ID" label-width="120">
				<el-input v-model="addsettingquery.tmall_shopid" placeholder="请填写天猫店铺ID"></el-input>
			</el-form-item>
			<el-form-item label="appkey" label-width="120">
				<el-input v-model="addsettingquery.tmall_appkey" placeholder="请填写Appkey"></el-input>
			</el-form-item>
			<el-form-item label="appsecret" label-width="120">
				<el-input v-model="addsettingquery.tmall_appsecret" placeholder="请填写Appsecret"></el-input>
			</el-form-item>
		</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" size="small" @click="savesettings" :loading="addsettingquery.loading">确定</el-button>
			<el-button size="small" @click="addsettingDialog = false">取 消</el-button>
		</div>
	</el-dialog>


    
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Tmall/index",
      transitionshow:true,
      actionauth:[],
	  query: {
		  act:'savetmall_setting',
		  token:this.$cookies.get('token'),
		  loading:false,
	  },
	  settings:[],

	  addsettingDialog:false,
	  addsettingquery: {
		  act:'addsetting',
		  token:this.$cookies.get('token'),
		  id:'',
		  tmall_shopid:'',
		  tmall_shopname:'',
		  tmall_appkey:'',
		  tmall_appsecret:'',
		  loading:false,
	  },
	  
      
    }
  },
  
  
  mounted(){
    this.getactionauth(); //获取权限设置
	this.getsetting();
  },
  
  
  methods:{

	/** 去授权 **/
	gotoauth(item) {
		if(item.status==1) {this.$message.warning("当前时间充足，无需再次重新授权"); return false;}
		var token_url='https://oauth.taobao.com/authorize?response_type=code&client_id='+item.tmall_appkey+'&redirect_uri='+this.GLOBAL.tmallreturnurl+'&state='+item.id+'&view=web';
		window.open(token_url);

	},


	/** 删除配置信息 **/
	delsetting(item) {
		var resource = this.$resource(this.url);
        resource.save({act:'delsettings',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
				this.getsetting();

            }
        }).catch((res) => {
            
        });
	},


	/** 获取配置信息 **/
	getsettinginfos(item) {
		this.addsettingDialog=true;
		this.addsettingquery.act='savesetting';
		var resource = this.$resource(this.url);
        resource.save({act:'getsettinginfos',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
				var result = JSON.parse(Base64.decode(res.data.Data));
				this.addsettingquery.id=result.id;
				this.addsettingquery.tmall_shopid=result.tmall_shopid;
				this.addsettingquery.tmall_shopname=result.tmall_shopname;
				this.addsettingquery.tmall_appkey=result.tmall_appkey;
				this.addsettingquery.tmall_appsecret=result.tmall_appsecret;

            }
        }).catch((res) => {
            
        });
	},


	/** 保存店铺设置信息 **/
	savesettings() {
		this.addsettingquery.loading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.addsettingquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
				this.addsettingquery.loading=false;
            }else{
				this.addsettingquery.loading=false;
				this.addsettingDialog=false;
				this.getsetting();
            }
        }).catch((res) => {
            this.addsettingquery.loading=false;
        });
	},


	/** 新增店铺设置 **/
	addsettingshop() {
		this.addsettingDialog=true;
		this.addsettingquery.act='addsetting';
		this.addsettingquery.id='';
		this.addsettingquery.tmall_shopid='';
		this.addsettingquery.tmall_shopname='';
		this.addsettingquery.tmall_appkey='';
		this.addsettingquery.tmall_appsecret='';
	},


	/** 获取配置信息 **/
	getsetting() {
		this.query.loading=true;
    	var resource = this.$resource(this.url);
		this.settings=[];
        resource.save({act:'gettmall_setting',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
				this.query.loading=false;
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
                this.settings=result;
				this.query.loading=false;
            }
        }).catch((res) => {
            this.query.loading=false;
        });
	},


	/** 修改配置信息 **/
	savesetting() {
		this.query.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
				this.query.loading=false;
            }else{
                this.query.loading=false;
				this.$message.success('修改配置信息成功');
            }
        }).catch((res) => {
			this.query.loading=false;
        });
	},

    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    
      
    
  }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}

.tmall_shop_setting_add {display:inline-block;width:100%;margin-bottom:50px;}
.tmall_shop_setting_add_notice {font-size:12px;color:red;margin-left:1%;}
.tmall_shop_lists {display:inline-block;width:calc(100% - 40px);font-size:0;padding:20px;}
.tmall_shop_lists_infos {transition:.3s all;display:inline-block;width:calc(25% - 2% - 2px);padding:10px 1% 5px 1%;background:#EBEEF5;border:1px solid #dddddd;border-radius:6px;margin:0 2% 10px 0;position:relative}
.tmall_shop_lists_infos:hover {box-shadow:5px 5px 10px #999999;}
.tmall_shop_lists_infos_sg {display:inline-block;width:100%}
.tmall_shop_lists_infos_shopname_title {float:left;width:65%;font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;}
.tmall_shop_lists_infos_shopname_button {float:left;width:35%;text-align:right}
.tmall_shop_lists_infos_shopname_content {float:left;width:100%;font-size:13px;line-height:23px;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;}

.tmall_shop_setting_status_error {position:absolute;width:40px;height:40px;padding:10px;top:0;left:0;margin:-15px 0 0 -15px;border-radius:50%;border:3px solid red;display:flex;justify-content:center;align-items:center;text-align:center;background:#fff;transform:rotate(-45deg);}
.tmall_shop_setting_status_error div {text-align:center;font-size:14x;font-weight:bold;color:red;line-height:23px}
.tmall_shop_setting_status_success {position:absolute;width:40px;height:40px;padding:10px;top:0;left:0;margin:-15px 0 0 -15px;border-radius:50%;border:3px solid #67C23A;display:flex;justify-content:center;align-items:center;text-align:center;background:#fff;transform:rotate(-45deg);}
.tmall_shop_setting_status_success div {text-align:center;font-size:14px;font-weight:bold;color:#67C23A;line-height:23px}

.tmall_shop_lists_infos_logo {position:absolute;width:30%;top:0;left:35%;margin-top:-35px;}
.tmall_shop_lists_infos_logo img {width:100%;height:35px;}
.tmall_shop_lists_infos_add_logo {float:left;width:100%;font-size:0;padding:0;}
.tmall_shop_lists_infos_add_logo img {width:40%;float:left;margin-left:30%;}

.tmall_shop_lists_infos_add_logo_content {display:inline-block;width:calc(100% - 40px - 2px);padding:30px 20px 10px 20px;background:#fff;border:1px solid #fff;border-radius:6px;}

.tmall_shop_lists_setting_dialog .el-dialog {background:#fef0f0;}
</style>


// WEBPACK FOOTER //
// src/components/tmall/TMallSettings.vue